import { isContinuityMicLabel } from "./DeviceManager";

// Virtual audio drivers that bypass the user's actual microphone. Including
// these as a fallback target would silently hand audio to a routing app
// instead of a real mic. Denylist is incomplete (Discord audio routers, less
// common drivers exist) — telemetry watch (manual mic change within 30s of
// switch) signals when extension is needed.
const VIRTUAL_DRIVER_PATTERNS = [
  /krisp/i,
  /zoomaudiodevice/i,
  /blackhole/i,
  /loopback/i,
  /soundflower/i,
  /vb-cable/i,
];

function isVirtualDriver(label: string): boolean {
  return VIRTUAL_DRIVER_PATTERNS.some((re) => re.test(label));
}

function isMacBookMicrophone(label: string): boolean {
  return /macbook/i.test(label) && /microphone/i.test(label);
}

function isBuiltIn(label: string): boolean {
  return /built-?in/i.test(label);
}

/**
 * Pick the best non-Continuity audio input device to suggest as a swap target.
 * Ranking: MacBook + Microphone → Built-in → first remaining (excluding
 * iPhone/iPad and known virtual drivers). Returns null when no eligible
 * candidate exists (caller should suppress the alert in that case).
 */
export function suggestedNonContinuityMic(
  devices: MediaDeviceInfo[],
): MediaDeviceInfo | null {
  const candidates = devices.filter((d) => {
    if (!d.label) return false;
    if (isContinuityMicLabel(d.label)) return false;
    if (isVirtualDriver(d.label)) return false;
    return true;
  });

  if (candidates.length === 0) return null;

  const macBook = candidates.find((d) => isMacBookMicrophone(d.label));
  if (macBook) return macBook;

  const builtIn = candidates.find((d) => isBuiltIn(d.label));
  if (builtIn) return builtIn;

  return candidates[0];
}
